import ColHeader from "../ColumnHeaders/ColHeader.jsx";
import AddColumn from "../ColumnHeaders/AddColumn";

import CustomPinnedRowRenderer from "../PinnedAggregateRow/CustomPinnedRowRenderer";
import CustomPinnedRowEditor from "../PinnedAggregateRow/CustomPinnedRowEditor";

import GroupedCellRenderer from "../GroupedAggregateCells/GroupedCellRenderer";
import FullWidthGroupedCellRenderer from "../GroupedAggregateCells/FullWidthGroupedCellRenderer";
import StarColumnRenderer from "../columnEditors/Star/StarColumnRenderer.js";
import StarColumnEditor from "../columnEditors/Star/StarColumnEditor.js";
import TextColumnEditor from "../columnEditors/Text/TextColumnEditor";
import TextColumnRenderer from "../columnEditors/Text/TextColumnRenderer";
import DropDownColumnEditor from "../columnEditors/DropDown/DropDownColumnEditor";
import DropDownColumnRenderer from "../columnEditors/DropDown/DropDownColumnRenderer";
import MultiLineColumnEditor from "../columnEditors/MultiLine/MultiLineColumnEditor";
import MultiLineColumnRenderer from "../columnEditors/MultiLine/MultiLineColumnRenderer";
import DateColumnRenderer from "../columnEditors/Date/DateColumnRenderer";
import DateColumnEditor from "../columnEditors/Date/DateColumnEditor";
import BooleanColumnEditor from "../columnEditors/Boolean/BooleanColumnEditor";
import BooleanColumnRenderer from "../columnEditors/Boolean/BooleanColumnRenderer";
import MultiselectColumnEditor from "../columnEditors/Multiselect/MultiselectColumnEditor";
import MultiselectColumnRenderer from "../columnEditors/Multiselect/MultiselectColumnRenderer";
import CheckboxGroupColumnEditor from "../columnEditors/CheckboxGroup/CheckboxGroupColumnEditor";
import CheckboxGroupColumnRenderer from "../columnEditors/CheckboxGroup/CheckboxGroupColumnRenderer";
import FileColumnEditor from "../columnEditors/FileOrAttachment/FileColumnEditor";
import FileColumnRenderer from "../columnEditors/FileOrAttachment/FileColumnRenderer";
import LookupColumnEditor from "../columnEditors/Lookup/LookupColumnEditor";
import LookupColumnRenderer from "../columnEditors/Lookup/LookupColumnRenderer";
import NumberColumnEditor from "../columnEditors/Number/NumberColumnEditor";
import NumberColumnRenderer from "../columnEditors/Number/NumberColumnRenderer";
import FormulaColumnRenderer from "../columnEditors/Formula/FormulaColumnRenderer";
import FormulaColumnEditor from "../columnEditors/Formula/FormulaColumnEditor";
import TriggerColumnRenderer from "../columnEditors/Triggers/TriggerColumnRenderer";
import EventsColumnRenderer from "../columnEditors/EventsColumnRenderer";
import EmailColumnRenderer from "../columnEditors/EmailColumnRenderer.js";
import CommentsIdColumnRenderer from "../columnEditors/CommentsIdColumnRenderer/CommentsIdColumnRenderer.js";
import CommentsIdColumnEditor from "../columnEditors/CommentsIdColumnRenderer/CommentsIdColumnEditor.js";
import SubsheetColumnEditor, {
  SubsheetColumnRenderer,
} from "../columnEditors/Subsheet/SubsheetColumnEditor";
import RowIdColumnRenderer from "../columnEditors/RowId/RowIdColumnRenderer";
import InjectReactEditor from "../utils/InjectReactEditor";
import InjectReactRenderer from "../utils/InjectReactRenderer";
import InjectReactFilter from "../utils/InjectReactFilter";
import InjectReactFloatingFilter from "../utils/InjectReactFloatingFilter";

import DateFilter from "../../../filters/Date/DateFilter";
import TextFilter from "../../../filters/Text/TextFilter";
import SearchFloatingFilter from "../../../filters/SearchFloatingFilter";
import { getTitle } from "./getTitle.js";
import PasswordRenderer from "../columnEditors/Password/PasswordRenderer.js";
import UserEventsRenderer from "../columnEditors/Triggers/UserEventsRenderer";

export function getGridComponents(store) {
  const cellMetaData = store.cellMetaData;

  return {
    customPinnedRowEditor: new InjectReactEditor(CustomPinnedRowEditor),
    textEditor: new InjectReactEditor(TextColumnEditor),
    dropdownEditor: new InjectReactEditor(DropDownColumnEditor),
    multiLineEditor: new InjectReactEditor(MultiLineColumnEditor),
    commentsIdEditor:new InjectReactEditor(CommentsIdColumnEditor),
    dateEditor: new InjectReactEditor(DateColumnEditor),
    booleanEditor: new InjectReactEditor(BooleanColumnEditor),
    starEditor: new InjectReactEditor(StarColumnEditor),
    multiselectEditor: new InjectReactEditor(MultiselectColumnEditor),
    checkboxGroupEditor: new InjectReactEditor(CheckboxGroupColumnEditor),
    formulaEditor: new InjectReactEditor(FormulaColumnEditor),
    fileEditor: new InjectReactEditor(FileColumnEditor),
    lookupEditor: new InjectReactEditor(LookupColumnEditor),
    numberEditor: new InjectReactEditor(NumberColumnEditor),
    subsheetEditor: new InjectReactEditor(SubsheetColumnEditor),
    agColumnHeader: new InjectReactRenderer(ColHeader),

    dateFilter: new InjectReactFilter(DateFilter),
    textFilter: new InjectReactFilter(TextFilter),
    searchFloatingFilter: new InjectReactFloatingFilter(SearchFloatingFilter),
    addColumnHeader: new InjectReactRenderer(AddColumn),
    commentsIdRenderer: CommentsIdColumnRenderer,
    starRenderer: StarColumnRenderer,
    rowIdRenderer: RowIdColumnRenderer,
    customPinnedRowRenderer: CustomPinnedRowRenderer,
    groupedCellRenderer: GroupedCellRenderer,
    fullWidthGroupedCellRenderer: new InjectReactRenderer(
      FullWidthGroupedCellRenderer
    ),
    dropdownRenderer: DropDownColumnRenderer,
    textRenderer: TextColumnRenderer,
    multiLineRenderer: MultiLineColumnRenderer,
    dateRenderer: DateColumnRenderer,
    booleanRenderer: BooleanColumnRenderer,
    multiselectRenderer: MultiselectColumnRenderer,
    checkboxGroupRenderer: CheckboxGroupColumnRenderer,
    formulaRenderer: FormulaColumnRenderer,
    fileRenderer: FileColumnRenderer,
    lookupRenderer: LookupColumnRenderer,
    numberRenderer: NumberColumnRenderer,
    subsheetRenderer: SubsheetColumnRenderer,
    passwordRenderer: PasswordRenderer,
    triggerRenderer: new InjectReactRenderer(TriggerColumnRenderer),
    userEventsRenderer: new InjectReactRenderer(UserEventsRenderer),
    eventRenderer: new InjectReactRenderer(EventsColumnRenderer),
    emailRenderer: new InjectReactRenderer(EmailColumnRenderer),
  };
}

function addTooltipToRenderer(Renderer, cellMetaData) {
  return (...args) => {
    const tooltip = getTitle(args[0], cellMetaData);

    if (!tooltip) {
      return `${Renderer(...args)}`;
    }

    const el = document.createElement("div");
    el.title = tooltip;
    el.innerHTML = `${Renderer(...args)}`;

    return el;
  };
}
